<template>
  <div class="c-banner-advertisement">
    <Swipe
      v-if="list.length"
      :autoplay-time="loopTime"
      class="banner-swipe"
    >
      <SwipeItem
        v-for="ad in list"
        :key="ad.id"
      >
        <a
          :href="ad.data.link"
          class="wrap"
        >
          <div :style="{backgroundImage: `url(${ad.toUrl})`}" class="ad">
            <!-- <h4 class="title">{{ ad.title }}</h4> -->
          </div>
        </a>
      </SwipeItem>
    </Swipe>
    <div v-else class="no-swiper" />
  </div>
</template>

<script>
  import 'c-swipe/dist/swipe.css'
  import { Swipe, SwipeItem } from 'c-swipe'
  import * as bootApi from '@/api/bootstrappers.js'
  import { mapState } from 'vuex'

  /**
   * 广告位类型映射表
   */
  const adMap = {
    'feed:hot': 'feed:list:top',
    news: 'news:list:top',
  }

  export default {
    name: 'FeedSwiper',
    components: { Swipe, SwipeItem },
    props: {
      loopTime: { type: Number, default: 3000 },
    },
    data () {
      return {
        list: [], // 轮播图列表
      }
    },
    computed: {
      ...mapState({
        ADVERTISEMENT: state => state.ADVERTISEMENT || {},
      }),
    },
    watch: {
      ADVERTISEMENT: {
        handler () {
          if (this.ADVERTISEMENT.length) {
            this.fetchList()
          }
        },
        immediate: true,
      },
    },
    mounted () {
      this.fetchList()
    },
    methods: {
      fetchList () {
        const id = ((this.ADVERTISEMENT.filter(item => item.space === 'h5:index:top')[0]) || [{ id: '' }]).id
        if (id) {
          bootApi.getAdsById(id).then(res => {
            // const originUrl = 'wonder.cn.kwm.com'
            // const replaceUrl = 'mwonder.cn.kwm.com/server'
            this.list = res.data.map((ad) => {
              let toUrl = ad.data.image
              // if (toUrl.indexOf(originUrl) !== -1) {
              //   ad.toUrl = toUrl.replace(originUrl, replaceUrl)
              // } else {
              //   ad.toUrl = toUrl
              // }
              ad.toUrl = toUrl
              return ad
            })
          })
        }
      },
    },
  }
</script>

<style lang="less" scoped>
.c-banner-advertisement {
  .banner-swipe {
    .wrap {
      @radio: 414 / 215; // banner 固定的宽高比

      height: calc(~"100vw / @{radio}"); // 由屏幕宽度计算出相应比例的高度
      position: relative;
      display: block;

      .title {
        position: absolute;
        bottom: 16px;
        width: 100%;
        text-align: center;
        color: #fff;
        font-size: 28px;
      }

      .ad {
        background: no-repeat center / cover;
        width: 100%;
        height: 100%;
      }
    }
  }
  .no-swiper {
    height: 100px;
    background-color: #1A1A1A;
  }
}
</style>
